import { cn } from "@gymflow/helpers";
import { Field, FieldProps, FormikProps } from "formik";

import {
  StaffSelectInput,
  StaffSelectInputOptionType,
  StaffSelectInputProps,
} from "../../../base/StaffSelectInput";
import { ErrorMessage } from "../../../ErrorMessage";
import { Path } from "../../types";

type FormStaffSelectInputProps<T> = {
  name: Path<T>;
  containerClassName?: string;
} & Omit<StaffSelectInputProps, "value" | "onChange">;

/***
 * @deprecated please do not use this component as reference to create similar ones, check out `FormSelectLeadSource` instead
 */
export const FormSelectStaff = <T,>({
  name,
  className,
  containerClassName,
  ...props
}: FormStaffSelectInputProps<T>) => (
  <Field name={name}>
    {({
      field,
      form: { setFieldValue },
      meta: { touched, error },
    }: FieldProps<
      StaffSelectInputOptionType | StaffSelectInputOptionType[],
      FormikProps<T>
    >) => {
      const isError = touched && error;
      return (
        <div className={cn("flex flex-col gap-1.5", containerClassName)}>
          <StaffSelectInput
            {...props}
            {...(props.isMulti
              ? {
                  isMulti: true,
                  value: (field.value as StaffSelectInputOptionType[]) ?? [],
                }
              : {
                  isMulti: false,
                  value: field.value as StaffSelectInputOptionType | undefined,
                })}
            onChange={(
              selected?:
                | StaffSelectInputOptionType
                | StaffSelectInputOptionType[],
            ) => setFieldValue(String(name), selected)}
            className={cn(className, {
              "outline-error-300 border-error-200": isError,
            })}
          />
          {isError && <ErrorMessage text={error} />}
        </div>
      );
    }}
  </Field>
);
